import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { lacTenantService } from '../../../services/LacTenantService';
import { lacQueryKeys } from '../lacQueryKeys';

export function useLacTenantsQuery() {
  const { user } = useAuth();

  return useQuery({
    queryKey: lacQueryKeys.tenants(),
    enabled: Boolean(user),
    queryFn: () => lacTenantService.listTenants(),
  });
}
